// You can customize the template with the help of this file
import envioloLogo from "@src/assets/images/logo/enviolo_bug_White-Navy_RGB_48px.png"

//Template config options
const themeConfig = {
  app: {
    appName: 'enviolo',
    appLogoImage: envioloLogo //require('@src/assets/images/logo/enviolo_bug_White-Navy_RGB_48px.png').default
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: false // Enable scroll to top button
  }
}

export default themeConfig
